module.exports = __webpack_public_path__ + "static/value-check-579b453a2b2f83e4158fd81e34c648b7.png";